import { type HTMLAttributes } from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center px-3 py-1 text-xs uppercase tracking-widest font-light transition-colors duration-300",
  {
    variants: {
      variant: {
        default:
          "bg-primary-100 text-primary-800 dark:bg-primary-800 dark:text-primary-200",
        secondary:
          "bg-primary-50 text-primary-600 dark:bg-primary-900 dark:text-primary-400",
        success:
          "bg-green-50 text-green-800 dark:bg-green-900/20 dark:text-green-200",
        warning:
          "bg-yellow-50 text-yellow-800 dark:bg-yellow-900/20 dark:text-yellow-200",
        destructive:
          "bg-red-50 text-red-800 dark:bg-red-900/20 dark:text-red-200",
        info: "bg-blue-50 text-blue-800 dark:bg-blue-900/20 dark:text-blue-200",
        teal: "bg-teal-50 text-teal-800 dark:bg-teal-900/20 dark:text-teal-200",
        outline:
          "border border-primary-200 dark:border-primary-800 text-primary-800 dark:text-primary-200 bg-transparent",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

export interface BadgeProps
  extends HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <span className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
